import { Box, IconButton, styled } from '@mui/material'
import {
  createImageAltTextFromFileName,
  getFullImageUrl,
  getStandardSrcset,
  LazyLoadWrapper,
} from '@trr/internal-helpers'
import { RelatedContentProps } from 'App/components/RelatedContent/RelatedContent'
import RelatedContent from 'App/components/RelatedContent'
import { IContentBlock } from 'App/Epi/BlockMapper/BlockMapper'
import Introduction, {
  IntroductionContentProps,
} from 'App/Epi/Blocks/Introduction/Introduction'
import HTMLMapper from 'App/Epi/HTMLMapper'
import blockMapper from 'App/Epi/BlockMapper'
import ArticleVideoBlock, {
  ArticleVideoBlockProps,
} from 'App/Epi/Blocks/ArticleVideoBlock/ArticleVideoBlock'
import { asyncMobilePageShare } from 'utils/helpers'
import { Share } from '@mui/icons-material'

interface GuideWithNavigationContentProps {
  introduction: IntroductionContentProps
  image: string
  videoProperties: ArticleVideoBlockProps[]
  editor: string
  blocks?: IContentBlock[]
  relatedContent?: RelatedContentProps[]
}

export const GuideWithNavigationContent = ({
  introduction,
  image,
  videoProperties,
  editor,
  blocks,
  relatedContent,
}: GuideWithNavigationContentProps) => {
  const { MEDIA_URL } = window.APP_CONFIGURATION.COMMON

  return (
    <>
      {introduction && <Introduction content={introduction} />}

      <Box
        width="100%"
        marginBottom={3}
        display="flex"
        justifyContent="flex-end"
      >
        <IconButton
          onClick={() => void asyncMobilePageShare(window.location.href)}
        >
          <Share />
        </IconButton>
      </Box>

      <Box marginBottom={3}>
        {image && (
          <LazyLoadWrapper>
            <Image
              src={getFullImageUrl(MEDIA_URL, image, 768)}
              alt={createImageAltTextFromFileName(image)}
              srcSet={getStandardSrcset(MEDIA_URL, image, [1140])}
              sizes="(max-width: 1236px) 100vw, 1140px"
            />
          </LazyLoadWrapper>
        )}
        {videoProperties.map((video) => (
          <ArticleVideoBlock key={video.properties.videoUrl} {...video} />
        ))}
      </Box>

      {editor && <HTMLMapper body={editor} wrapper={'section'} />}
      {blocks && blocks?.length > 0 && <>{blockMapper({ blocks })}</>}

      {relatedContent && relatedContent?.length > 0 && (
        <RelatedContent relatedContent={relatedContent} fallbackImage="" />
      )}
    </>
  )
}

const Image = styled('img')(() => ({
  width: '100%',
  objectFit: 'cover',
  marginBottom: 4,
}))
